<template>
  	<div>
		<v-layout wrap>
			<v-flex xs12 mt-4>
				<app-table
					title="Encuestas"
					:name="name"
					:clean-search="cleanSearch"
					:filter-columns="false"
					:rows="rows"
					:columns="columns"
					:main-list="false"
					class="is-not-selectable no-main-list"
					@on-search-event="$emit('on-search', $event)"
				>
					<template slot="rows" slot-scope="props">
						<td
							v-show="showRow(columns, 1)"
							:class="[
							'is-not-selectable',
						]"
						:style="`border-left:2px solid ${props.row.numDiagnostics === 0 ? $appColors.error : 'transparent'}`"
						>{{ props.row.name }}</td>
						<td
							v-show="showRow(columns, 2)"
							:style="`color:${props.row.numDiagnostics === 0 ? $appColors.error : $appColors.info}`"
						>{{props.row.numDiagnostics}}</td>
						<td v-show="showRow(columns, 3)">{{props.row.numAnswered}}/{{props.row.numApplicants}}</td>
						<td v-show="showRow(columns, 4)">{{ props.row.createdAt | formatDate }}</td>
						<td v-show="showRow(columns, 5)" @click.stop="stopClick">
							<v-layout wrap align-center justify-start pl-2>
								<app-tooltip-button
									img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/copy-action.svg"
									size="18"
									text="Duplicar"
									@click-icon="$emit('on-click', { action: 'clone', row: props.row })"
								/>
								<v-tooltip top>
									<v-switch
										class="switch-table ma-0 pt-2"
										color="success"
										slot="activator"
										v-model="props.row.state"
										:true-value="1"
										:false-value="0"
										hide-details
										@change="$emit('on-click', { action: 'state', row: props.row })"
									></v-switch>
									<span>{{ stateName(props.row) }}</span>
								</v-tooltip>
								<app-tooltip-button
									v-if="!!props.row.flagDelete"
									img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
									size="18"
									text="Duplicar"
									@click-icon="$emit('on-click', { action: 'delete', row: props.row })"
								/>
							</v-layout>
						</td>
					</template>
				</app-table>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import appHeader from '@/components/shared/app-header';
import appSidebar from '@/components/shared/app-sidebar';

function stateName({ state }) {
	return state ? 'Activa' : 'Inactiva';
}

export default {
	name: 'survey-table',
	components: {
		appHeader,
		appSidebar,
	},
	methods: {
		stateName,
	},
	props: {
		cleanSearch: {
			default: false,
			type: Boolean,
		},
		columns: {
			default: () => [],
			type: Array,
		},
		name: String,
		rows: {
			default: () => [],
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/surveys/survey-table.vue